<template>
  <div class="box-outer">
    <div class="title">
      {{ $t('SIGN.SHARED.CONGRATULATIONS.CASE_NOT_FOUND') }}
    </div>

    <p class="msg">
      {{ $t('SIGN.SHARED.CONGRATULATIONS.CONTACT_US') }}
    </p>

    <div class="navigation">
      <button-component tag="router-link" class="button" to="dashboard" yellow>
        {{ $t('back') }}
      </button-component>
    </div>
  </div>
</template>

<script>
import ButtonComponent from '@/components/Button'

export default {
  components: {
    ButtonComponent
  }
}
</script>

<style lang="scss" scoped>
.title {
  margin: 32px 0 34px;
  font-size: 30px;
  font-weight: 500;
  text-align: center;

  @include media-down(md) {
    margin: 32px auto;
  }
}

.msg {
  width: 100%;
  padding: 25px 0;
  margin: 10px auto;
  text-align: center;
  font-size: 16px;
  background: #f2f2f2;
}

.navigation {
  display: flex;
  justify-content: center;
  padding: 40px 0;

  .button {
    max-width: 300px;
  }
}
</style>
